module.exports = __webpack_public_path__ + "static/media/FlashSale.be6e8ef6.svg";